export default "__VITE_PUBLIC_ASSET__de03d053__"